import { Component } from '@angular/core';
import { ListService } from '@fry/lib/list';


@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css'],
    providers: [
        ListService
    ],
    standalone: false
})
export class UsersComponent {

  constructor(
  ) { }

}
